<template>
  <div id="grid-cronograma">
    <v-container grid-list-xl fluid>
      <div v-if="loading">
        <loading></loading>
      </div>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
          :tipoCarga="tipoCarga"
        ></carga-masiva>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="name"
            item-value="code"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md8>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
          >
          </v-select>
        </v-flex>

        <v-btn fab dark color="teal" title="Filtrar detalle" @click="filtro()">
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="datosPaginados"
            :page.sync="page"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
            @page-count="pageCount = $event"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.total }}</td>
              <td class="text-xs-left">{{ props.item.recibidos }}</td>
              <div class="text-xs-center">
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consultar detalle"
                    @click="
                      view(
                        props.item.idNivel,
                        props.item.tipoPrueba,
                        props.item.nivel
                      )
                    "
                    ><v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </div>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA  -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar detalle
                </template>
              </td>
            </div>
          </v-card-actions>

          <!--  dsoto 10-11-2022 -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="cantRegistros"
              disabled
            ></v-text-field>
          </v-flex>
          <!--  dsoto 10-11-2022 -->

          <!-- DSOTO 27-10-2022  -->
          <div class="text-center pt-2">
            <v-pagination
              @input="changePage(page)"
              v-model="page"
              :length="pageCount"
              :total-visible="9"
              circle
            >
            </v-pagination>
          </div>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import CargaMasiva from "@/components/CargaMasiva.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-recepcion",
  components: {
    Loading,
    CargaMasiva,
    LoadingDescarga,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      dialogLoading: false,
      botonValida: 1,
      loading: false,
      itemsRegistro: [],
      dialogValidation: false,
      dialog: false,
      rowsPerPageItems: [20],
      // pagination: {
      //   rowsPerPage: 50
      // },
      contratoId: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        {
          text: "Tipo Prueba",
          align: "left",
          sortable: false,
          value: "region",
        },
        { text: "Total a Recibir", sortable: false, value: "centroAcopio" },
        { text: "Recibidos", sortable: false, value: "centroOperacion" },
        { text: "Accion", sortable: false, value: "accion" },
      ],
      nivelValue: null,
      nivelSelect: [],
      tipoPruebaValue: null,
      tipoPruebaSelect: [],
      tabSelected: "",
      tipo_prueba: "",
      nivel: "",
      id_nivel: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
      tipoCarga: "CSV",

      // dsoto 08-11-2022
      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
    };
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument =
      "/capturaRecepcion/preProcessCapturaRecepcionMasivo";
    this.apiSaveDocument = "/capturaRecepcion/GuardarCapturaRecepcionMasivo";
    this.apiDownloadDocument =
      "/CapturaRecepcion/downloadPlantillaCapturaRecepcion/";
    this.templateTitle = "Planilla_Recepcion";
    this.loadData();
  },
  mounted() {},
  computed: {},
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  methods: {
    view(id_nivel, tipo_prueba, nivel) {
      setTimeout(() => {
        this.$router.push({
          name: "FormRecepcionCaptura",
          params: {
            id_nivel: id_nivel,
            tipeView: "consulta",
            titleView: "Consulta Recepcion",
            tipo_prueba: tipo_prueba,
            nivel: nivel,
          },
        });
      }, 1000);
    },

    async loadRegistrosFilter() {
      this.body = {
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        nivelCode: this.nivelValue,
      };
      return await axios
        .post("/capturaRecepcion/sumaryRecepcion", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsRegistro = await this.loadRegistrosFilter();
      this.loading = false;

      if (this.itemsRegistro.length > 0) {
        this.cantRegistros = this.itemsRegistro.length;
        this.pageCount = Math.ceil(
          this.itemsRegistro.length / this.rowsPerPageItems
        );
        this.getDataPagina(this.page); // dsoto 09-11-2022

        this.loadNivelSelect();
        this.loadTipoPrueba();
      }
    },

    loadNivelSelect() {
      let niv = [];
      this.itemsRegistro.forEach(function (c) {
        let index = niv.findIndex((x) => x.id_nivel == c.idNivel);
        if (index === -1 && c.idNivel != null && c.idNivel != "") {
          niv.push({ name: c.nivel, code: c.idNivel });
        }
      });
      this.nivelSelect = niv;
    },

    loadTipoPrueba() {
      let tip = [];
      this.itemsRegistro.forEach(function (c) {
        let index = tip.findIndex((x) => x.tipo_prueba == c.tipoPrueba);
        if (index === -1) {
          tip.push(c.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    filtro() {
      this.loadData();
    },
    clear() {
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.loadData();
    },

    // dsoto
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      console.log(this.page);
      this.getDataPagina(this.page);
    },
    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsRegistro.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      this.datosPaginados = this.itemsRegistro.slice(
        0,
        this.itemsRegistro.length
      );
    },
  },
};
</script>
